var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerClass"},[_c('div',{staticClass:"titleClass"},[_vm._v(" Scan QR code to get the official APP 😎 ")]),_c('img',{style:(_vm.styleQrCode),attrs:{"src":_vm.qrcodeImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }